/**
 * @author Daniel Aguirre
 * @file actions.js
 * @description Parameter Actions
 */
// Constants
import {
  GET_RECOMMENDED_BY_SCHEDULING,
  GET_RECOMMENDED_BY_SCHEDULING_LIST,
  GET_ANTIBODY_ANTI_HBS,
  GET_ANTIBODY_ANTI_HBS_LIST,
  GET_INDI_BLOOD_PRESSURE_MONITORING,
  GET_INDI_GLUCOSE_MONITORING,
  GET_INDI_GLUCOSE_MONITORING_LIST,
  GET_INDI_BLOOD_PRESSURE_MONITORING_LIST,
  GET_ALBUMINURIA_PROGRESS,
  GET_ALBUMINURIA_PROGRESS_LIST,
  GET_ALBUMINURIA_PROGRESS_LIST_PLUS,
  GET_ALBUMINURIA_F13,
  GET_ALBUMINURIA_F13_LIST,
  GET_TFG_DETERIORATION,
  GET_TFG_DETERIORATION_LIST,
  GET_NUTRITIONAL_INDICATOR,
  GET_NUTRITIONAL_INDICATOR_LIST,
  GET_HEMOGLOBIN,
  GET_HEMOGLOBIN_LIST,
  GET_POTASSIUM,
  GET_POTASSIUM_LIST,
  GET_MISSED_APPOINTMENTS_BY_STAGE,
  GET_MISSED_APPOINTMENTS_BY_STAGE_LIST,
  GET_PROTEINURIA,
  GET_PROTEINURIA_DETAIL,
  GET_PROTEINURIA_LIST_PLUS,
  GET_METABOLIC_CONTROL_DIABETES,
  GET_METABOLIC_CONTROL_DIABETES_LIST,
  GET_METABOLIC_CONTROL_DIABETES_LIST_PLUS,
  GET_PHOSPHORUS,
  GET_PHOSPHORUS_LIST,
  GET_ALBUMINA,
  GET_ALBUMINA_LIST,
  GET_PTH_INDICATOR,
  GET_PTH_INDICATOR_LIST,
  GET_SEROSTATUS_HEPATITIS_B,
  GET_SEROSTATUS_HEPATITIS_B_LIST,
  GET_RISK,
  GET_RISK_LIST,
  GET_RISK_LIST_PLUS,
  GET_BLOOD_PRESSURE,
  GET_BLOOD_PRESSURE_LIST,
  GET_VACCINE_SCHEDULING,
  GET_VACCINE_SCHEDULING_LIST,
  GET_POST_VACCINE_ANTI_HBS,
  GET_POST_VACCINE_ANTI_HBS_LIST,
  GET_RISK_REGISTER,
  GET_RISK_REGISTER_LIST,
  GET_LOSS_HEPATITIS_IMMUNITY,
  GET_LOSS_HEPATITIS_IMMUNITY_LIST,
  GET_CORRELATION_RISK_RATE_PROGRESSION,
  GET_CORRELATION_RISK_RATE_PROGRESSION_LIST,
  GET_CORRELATION_RISK_RATE_PROGRESSION_LIST_PLUS,
  GET_TREATMENT_OPTIONS,
  GET_TREATMENT_OPTIONS_LIST,
  GET_TREATMENT_OPTIONS_LIST_PLUS,
  GET_PSYCHOSOCIAL_RISK,
  GET_PSYCHOSOCIAL_RISK_LIST,
  GET_PSYCHOSOCIAL_RISK_PSYCHOLOGY,
  GET_PSYCHOSOCIAL_RISK_PSYCHOLOGY_LIST,
  GET_ACCESS,
  GET_ACCESS_LIST,
  GET_ACCESS_LIST_PLUS,
  GET_SCHEDULING_ALERT,
  GET_SCHEDULING_ALERT_LIST,
  GET_SCHEDULING_ALERT_LIST_PLUS,
  GET_PROTEIN_ENERGETIC_WEAR,
  GET_PROTEIN_ENERGETIC_WEAR_LIST,
  GET_PROTEIN_ENERGETIC_WEAR_LIST_PLUS,
  GET_GENERAL_SOCIAL_T_SOCIAL_RISK,
  GET_GENERAL_SOCIAL_T_SOCIAL_RISK_LIST,
  GET_ASSESMENT_IN_PSYCHOLOGY,
  GET_ASSESMENT_IN_PSYCHOLOGY_LIST,
  GET_NURSING_EDUCATION,
  GET_NURSING_EDUCATION_LIST,
  GET_NURSING_EDUCATION_LIST_PLUS,
  GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT_LIST,
  GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT_LIST_PLUS,
  GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT,
  GET_PATIENT_EVENTS,
  GET_PATIENT_EVENTS_LIST,
  GET_PATIENT_EVENTS_LIST_PLUS,
  GET_PERIODICITY_ATTENTION,
  GET_PERIODICITY_ATTENTION_LIST,
  GET_CONSTRUCTION_ACCESS_ASSESSMENT,
  GET_CONSTRUCTION_ACCESS_ASSESSMENT_LIST,
  GET_CONSTRUCTION_ACCESS_ASSESSMENT_LIST_PLUS,
  GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE,
  GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE_LIST,
  GET_GENERAL_SOCIAL_RISK_REGISTER,
  GET_GENERAL_SOCIAL_RISK_REGISTER_LIST,
  GET_ADMON_CODES_BY_ENTITY,
  GET_MISSED_APPOINTMENTS_BY_STAGE_LIST_PLUS,
  GET_ANTIBODY_ANTI_HBS_LIST_PLUS,
  GET_VACCINE_SCHEDULING_LIST_PLUS,
  GET_LOSS_HEPATITIS_IMMUNITY_LIST_PLUS,
  GET_ALBUMINURIA_F13_LIST_PLUS,
  GET_TFG_DETERIORATION_LIST_PLUS,
  GET_RISK_REGISTER_LIST_PLUS,
  GET_BLOOD_PRESSURE_LIST_PLUS,
  GET_NUTRITIONAL_INDICATOR_LIST_PLUS,
  GET_ALBUMINA_LIST_PLUS,
  GET_HEMOGLOBIN_LIST_PLUS,
  GET_PSYCHOSOCIAL_RISK_PSYCHOLOGY_LIST_PLUS,
  GET_PHOSPHORUS_LIST_PLUS,
  GET_POTASSIUM_LIST_PLUS,
  GET_PTH_INDICATOR_LIST_PLUS,
  GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE_LIST_PLUS,
  GET_PSYCHOSOCIAL_RISK_LIST_PLUS,
  GET_GENERAL_SOCIAL_T_SOCIAL_RISK_LIST_PLUS,
  GET_GENERAL_SOCIAL_RISK_REGISTER_LIST_PLUS,
  GET_INDI_BLOOD_PRESSURE_MONITORING_LIST_PLUS,
  GET_INDI_GLUCOSE_MONITORING_LIST_PLUS,
  GET_LAST_UPDATE
} from './constants';

/**
 * Call process to get RecommendedByScheduling info
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_RECOMMENDED_BY_SCHEDULING
 */
export const getRecommendedByScheduling = (data, callback) => ({
  type: GET_RECOMMENDED_BY_SCHEDULING,
  payload: { data },
  callback
});

/**
 * Call process to get RecommendedByScheduling list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_RECOMMENDED_BY_SCHEDULING_LIST
 */
export const getRecommendedBySchedulingList = (data, callback) => ({
  type: GET_RECOMMENDED_BY_SCHEDULING_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get getMissedAppointmentsByStage info
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_RECOMMENDED_BY_SCHEDULING
 */
export const getMissedAppointmentsByStage = (data, callback) => ({
  type: GET_MISSED_APPOINTMENTS_BY_STAGE,
  payload: { data },
  callback
});

/**
 * Call process to get getMissedAppointmentsByStage list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_RECOMMENDED_BY_SCHEDULING_LIST
 */
export const getMissedAppointmentsByStageList = (data, callback) => ({
  type: GET_MISSED_APPOINTMENTS_BY_STAGE_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get getMissedAppointmentsByStage list plus
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_RECOMMENDED_BY_SCHEDULING_LIST
 */
export const getMissedAppointmentsByStageListPlus = (data, callback) => ({
  type: GET_MISSED_APPOINTMENTS_BY_STAGE_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get AntibodyAntiHBs info
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ANTIBODY_ANTI_HBS
 */
export const getAntibodyAntiHBs = (data, callback) => ({
  type: GET_ANTIBODY_ANTI_HBS,
  payload: { data },
  callback
});

/**
 * Call process to get AntibodyAntiHBs list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ANTIBODY_ANTI_HBS_LIST
 */
export const getAntibodyAntiHBsList = (data, callback) => ({
  type: GET_ANTIBODY_ANTI_HBS_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get AntibodyAntiHBs list plus
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ANTIBODY_ANTI_HBS_LIST
 */
export const getAntibodyAntiHBsListPlus = (data, callback) => ({
  type: GET_ANTIBODY_ANTI_HBS_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get getIndiBloodPressureMonitoring info
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_INDI_BLOOD_PRESSURE_MONITORING
 */
export const getIndiBloodPressureMonitoring = (data, callback) => ({
  type: GET_INDI_BLOOD_PRESSURE_MONITORING,
  payload: { data },
  callback
});

/**
 * Call process to get getIndiBloodPressureMonitoring list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_AMBULATORY_MONITORING_LIST
 */
export const getIndiBloodPressureMonitoringList = (data, callback) => ({
  type: GET_INDI_BLOOD_PRESSURE_MONITORING_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get getIndiBloodPressureMonitoring list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_AMBULATORY_MONITORING_LIST
 */
export const getIndiBloodPressureMonitoringListPlus = (data, callback) => ({
  type: GET_INDI_BLOOD_PRESSURE_MONITORING_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get getIndiGlucoseMonitoring info
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_INDI_GLUCOSE_MONITORING
 */
export const getIndiGlucoseMonitoring = (data, callback) => ({
  type: GET_INDI_GLUCOSE_MONITORING,
  payload: { data },
  callback
});

/**
 * Call process to get getIndiGlucoseMonitoring list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_AMBULATORY_MONITORING_LIST
 */
export const getIndiGlucoseMonitoringList = (data, callback) => ({
  type: GET_INDI_GLUCOSE_MONITORING_LIST,
  payload: { data },
  callback
});
/**
 * Call process to get getIndiGlucoseMonitoring list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_AMBULATORY_MONITORING_LIST
 */
export const getIndiGlucoseMonitoringListPlus = (data, callback) => ({
  type: GET_INDI_GLUCOSE_MONITORING_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get AlbuminuriaProgress info
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALBUMINURIA_PROGRESS
 */
export const getAlbuminuriaProgress = (data, callback) => ({
  type: GET_ALBUMINURIA_PROGRESS,
  payload: { data },
  callback
});

/**
 * Call process to get AlbuminuriaProgress info plus
 * @param  { object } data - Pagination data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALBUMINURIA_PROGRESS_LIST_PLUS
 */
export const getAlbuminuriaProgressListPlus = (data, callback) => ({
  type: GET_ALBUMINURIA_PROGRESS_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get AlbuminuriaProgress list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALBUMINURIA_PROGRESS_LIST
 */
export const getAlbuminuriaProgressList = (data, callback) => ({
  type: GET_ALBUMINURIA_PROGRESS_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get AlbuminuriaF13 info
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALBUMINURIA_PROGRESS
 */
export const getAlbuminuriaF13 = (data, callback) => ({
  type: GET_ALBUMINURIA_F13,
  payload: { data },
  callback
});

/**
 * Call process to get AlbuminuriaF13 list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALBUMINURIA_PROGRESS_LIST
 */
export const getAlbuminuriaF13List = (data, callback) => ({
  type: GET_ALBUMINURIA_F13_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get AlbuminuriaF13 list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALBUMINURIA_PROGRESS_LIST
 */
export const getAlbuminuriaF13ListPlus = (data, callback) => ({
  type: GET_ALBUMINURIA_F13_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get TFGDeterioration info
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_TFG_DETERIORATION
 */
export const getTFGDeterioration = (data, callback) => ({
  type: GET_TFG_DETERIORATION,
  payload: { data },
  callback
});

/**
 * Call process to get TFGDeterioration list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_TFG_DETERIORATION_LIST
 */
export const getTFGDeteriorationList = (data, callback) => ({
  type: GET_TFG_DETERIORATION_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get TFGDeterioration list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_TFG_DETERIORATION_LIST
 */
export const getTFGDeteriorationListPlus = (data, callback) => ({
  type: GET_TFG_DETERIORATION_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get NutritionalIndicator
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_NUTRITIONAL_INDICATOR
 */
export const getNutritionalIndicator = (data, callback) => ({
  type: GET_NUTRITIONAL_INDICATOR,
  payload: { data },
  callback
});

/**
 * Call process to get NutritionalIndicator  list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_NUTRITIONAL_INDICATOR_LIST
 */
export const getNutritionalIndicatorList = (data, callback) => ({
  type: GET_NUTRITIONAL_INDICATOR_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get NutritionalIndicator  list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_NUTRITIONAL_INDICATOR_LIST
 */
export const getNutritionalIndicatorListPlus = (data, callback) => ({
  type: GET_NUTRITIONAL_INDICATOR_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get Hemoglobin
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_HEMOGLOBIN
 */
export const getHemoglobin = (data, callback) => ({
  type: GET_HEMOGLOBIN,
  payload: { data },
  callback
});

/**
 * Call process to get Hemoglobin list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_HEMOGLOBIN_LIST
 */
export const getHemoglobinList = (data, callback) => ({
  type: GET_HEMOGLOBIN_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get Hemoglobin list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_HEMOGLOBIN_LIST
 */
export const getHemoglobinListPlus = (data, callback) => ({
  type: GET_HEMOGLOBIN_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get Potassium
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_POTASSIUM
 */
export const getPotassium = (data, callback) => ({
  type: GET_POTASSIUM,
  payload: { data },
  callback
});

/**
 * Call process to get Potassium list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_POTASSIUM_LIST
 */
export const getPotassiumList = (data, callback) => ({
  type: GET_POTASSIUM_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get Potassium list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_POTASSIUM_LIST
 */
export const getPotassiumListPlus = (data, callback) => ({
  type: GET_POTASSIUM_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get Proteinuria
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PROTEINURIA
 */
export const getProteinuria = (data, callback) => ({
  type: GET_PROTEINURIA,
  payload: { data },
  callback
});

/** Call process to get Risk list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PROTEINURIA
 */
export const getProteinuriaListPlus = (data, callback) => ({
  type: GET_PROTEINURIA_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get Metabolic Control Diabetes
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_METABOLIC_CONTROL_DIABETES
 */
export const getMetabolicControlDiabetes = (data, callback) => ({
  type: GET_METABOLIC_CONTROL_DIABETES,
  payload: { data },
  callback
});

/**
 * Call process to get  Metabolic Control Diabetes
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_METABOLIC_CONTROL_DIABETES_PLUS
 */
export const getMetabolicControlDiabetesListPlus = (data, callback) => ({
  type: GET_METABOLIC_CONTROL_DIABETES_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get Proteinuria detail
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PROTEINURIA
 */
export const getProteinuriaDetail = (data, callback) => ({
  type: GET_PROTEINURIA_DETAIL,
  payload: { data },
  callback
});

/** Call process to get Metabolic Control Diabetes list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_METABOLIC_CONTROL_DIABETES_LIST
 */
export const getMetabolicControlDiabetesList = (data, callback) => ({
  type: GET_METABOLIC_CONTROL_DIABETES_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get Phosphorus
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PHOSPHORUS
 */
export const getPhosphorus = (data, callback) => ({
  type: GET_PHOSPHORUS,
  payload: { data },
  callback
});

/**
 * Call process to get Phosphorus list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PHOSPHORUS_LIST
 */
export const getPhosphorusList = (data, callback) => ({
  type: GET_PHOSPHORUS_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get Phosphorus list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PHOSPHORUS_LIST
 */
export const getPhosphorusListPlus = (data, callback) => ({
  type: GET_PHOSPHORUS_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get Albumina
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALBUMINA
 */
export const getAlbumina = (data, callback) => ({
  type: GET_ALBUMINA,
  payload: { data },
  callback
});

/**
 * Call process to get Albumina list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALBUMINA_LIST
 */
export const getAlbuminaList = (data, callback) => ({
  type: GET_ALBUMINA_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get Albumina list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALBUMINA_LIST
 */
export const getAlbuminaListPlus = (data, callback) => ({
  type: GET_ALBUMINA_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get PTH
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PTH_INDICATOR
 */
export const getPthIndicator = (data, callback) => ({
  type: GET_PTH_INDICATOR,
  payload: { data },
  callback
});

/**
 * Call process to get PTH list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PTH_INDICATOR_LIST
 */
export const getPthIndicatorList = (data, callback) => ({
  type: GET_PTH_INDICATOR_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get PTH list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PTH_INDICATOR_LIST
 */
export const getPthIndicatorListPlus = (data, callback) => ({
  type: GET_PTH_INDICATOR_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get SeroStatusHepatitisB
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_SEROSTATUS_HEPATITIS_B
 */
export const getSeroStatusHepatitisB = (data, callback) => ({
  type: GET_SEROSTATUS_HEPATITIS_B,
  payload: { data },
  callback
});

/**
 * Call process to get SeroStatusHepatitisB list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_SEROSTATUS_HEPATITIS_B_LIST
 */
export const getSeroStatusHepatitisBList = (data, callback) => ({
  type: GET_SEROSTATUS_HEPATITIS_B_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get Risk
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_RISK
 */
export const getRisk = (data, callback) => ({
  type: GET_RISK,
  payload: { data },
  callback
});

/**
 * Call process to get Risk list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_RISK_LIST
 */
export const getRiskList = (data, callback) => ({
  type: GET_RISK_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get AlbuminuriaProgress info plus
 * @param  { object } data - Pagination data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALBUMINURIA_PROGRESS_LIST_PLUS
 */
export const getRiskListPlus = (data, callback) => ({
  type: GET_RISK_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get blood pressure indicator
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_BLOOD_PRESSURE
 */
export const getBloodPressure = (data, callback) => ({
  type: GET_BLOOD_PRESSURE,
  payload: { data },
  callback
});

/** Call process to get Risk
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_VACCINE_SCHEDULING
 */
export const getVaccineScheduling = (data, callback) => ({
  type: GET_VACCINE_SCHEDULING,
  payload: { data },
  callback
});

/**
 * Call process to get blood pressure indicator list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_BLOOD_PRESSURE_LIST
 */
export const getBloodPressureList = (data, callback) => ({
  type: GET_BLOOD_PRESSURE_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get blood pressure indicator list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_BLOOD_PRESSURE_LIST
 */
export const getBloodPressureListPlus = (data, callback) => ({
  type: GET_BLOOD_PRESSURE_LIST_PLUS,
  payload: { data },
  callback
});

/** Call process to get Risk list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_VACCINE_SCHEDULING_LIST
 */
export const getVaccineSchedulingList = (data, callback) => ({
  type: GET_VACCINE_SCHEDULING_LIST,
  payload: { data },
  callback
});

/** Call process to get Risk list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_VACCINE_SCHEDULING_LIST
 */
export const getVaccineSchedulingListPlus = (data, callback) => ({
  type: GET_VACCINE_SCHEDULING_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get PostVaccineAntiHbs
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_POST_VACCINE_ANTI_HBS
 */
export const getPostVaccineAntiHbs = (data, callback) => ({
  type: GET_POST_VACCINE_ANTI_HBS,
  payload: { data },
  callback
});

/**
 * Call process to get PostVaccineAntiHbs list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_POST_VACCINE_ANTI_HBS_LIST
 */
export const getPostVaccineAntiHbsList = (data, callback) => ({
  type: GET_POST_VACCINE_ANTI_HBS_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get RiskRegister
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_RISK_REGISTER
 */
export const getRiskRegister = (data, callback) => ({
  type: GET_RISK_REGISTER,
  payload: { data },
  callback
});

/**
 * Call process to get RiskRegister list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_RISK_REGISTER_LIST
 */
export const getRiskRegisterList = (data, callback) => ({
  type: GET_RISK_REGISTER_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get RiskRegister list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_RISK_REGISTER_LIST
 */
export const getRiskRegisterListPlus = (data, callback) => ({
  type: GET_RISK_REGISTER_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get LossHepatitisImmunity
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_LOSS_HEPATITIS_IMMUNITY
 */
export const getLossHepatitisImmunity = (data, callback) => ({
  type: GET_LOSS_HEPATITIS_IMMUNITY,
  payload: { data },
  callback
});

/**
 * Call process to get LossHepatitisImmunity list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_LOSS_HEPATITIS_IMMUNITY_LIST
 */
export const getLossHepatitisImmunityList = (data, callback) => ({
  type: GET_LOSS_HEPATITIS_IMMUNITY_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get LossHepatitisImmunity list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_LOSS_HEPATITIS_IMMUNITY_LIST
 */
export const getLossHepatitisImmunityListPlus = (data, callback) => ({
  type: GET_LOSS_HEPATITIS_IMMUNITY_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get CorrelationRiskRateProgression
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_CORRELATION_RISK_RATE_PROGRESSION
 */
export const getCorrelationRiskRateProgression = (data, callback) => ({
  type: GET_CORRELATION_RISK_RATE_PROGRESSION,
  payload: { data },
  callback
});

/**
 * Call process to get CorrelationRiskRateProgression list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_CORRELATION_RISK_RATE_PROGRESSION_LIST
 */
export const getCorrelationRiskRateProgressionList = (data, callback) => ({
  type: GET_CORRELATION_RISK_RATE_PROGRESSION_LIST,
  payload: { data },
  callback
});

/** Call process to get CorrelationRiskRateProgression list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_CORRELATION_RISK_RATE_PROGRESSION_LIST
 */
export const getCorrelationRiskRateProgressionListPlus = (data, callback) => ({
  type: GET_CORRELATION_RISK_RATE_PROGRESSION_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get TreatmentOptions
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_TREATMENT_OPTIONS
 */
export const getTreatmentOptions = (data, callback) => ({
  type: GET_TREATMENT_OPTIONS,
  payload: { data },
  callback
});

/**
 * Call process to get TreatmentOptions list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_TREATMENT_OPTIONS_LIST
 */
export const getTreatmentOptionsList = (data, callback) => ({
  type: GET_TREATMENT_OPTIONS_LIST,
  payload: { data },
  callback
});

/** Call process to get treatment
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ACCESS_LIST_PLUS
 */
export const getTreatmentOptionsListPlus = (data, callback) => ({
  type: GET_TREATMENT_OPTIONS_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get Psychosocial Risk
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PSYCHOSOCIAL_RISK_PSYCHOLOGY
 */
export const getPsychosocialRiskPsychology = (data, callback) => ({
  type: GET_PSYCHOSOCIAL_RISK_PSYCHOLOGY,
  payload: { data },
  callback
});

/**
 * Call process to get Psychosocial Risk list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PSYCHOSOCIAL_RISK_PSYCHOLOGY_LIST
 */
export const getPsychosocialRiskPsychologyList = (data, callback) => ({
  type: GET_PSYCHOSOCIAL_RISK_PSYCHOLOGY_LIST,
  payload: { data },
  callback
});

/** Call process to get psychosocialRiskpsychology
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ACCESS_LIST_PLUS
 */
export const getPsychosocialRiskPsychologyListPlus = (data, callback) => ({
  type: GET_PSYCHOSOCIAL_RISK_PSYCHOLOGY_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get Psychosocial Risk
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PSYCHOSOCIAL_RISK
 */
export const getPsychosocialRisk = (data, callback) => ({
  type: GET_PSYCHOSOCIAL_RISK,
  payload: { data },
  callback
});

/**
 * Call process to get Psychosocial Risk list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PSYCHOSOCIAL_RISK_LIST
 */
export const getPsychosocialRiskList = (data, callback) => ({
  type: GET_PSYCHOSOCIAL_RISK_LIST,
  payload: { data },
  callback
});

/** Call process to get Access list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ACCESS_LIST_PLUS
 */
export const getPsychosocialRiskListPlus = (data, callback) => ({
  type: GET_PSYCHOSOCIAL_RISK_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get Access
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ACCESS
 */
export const getAccess = (data, callback) => ({
  type: GET_ACCESS,
  payload: { data },
  callback
});

/**
 * Call process to get Access list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ACCESS_LIST
 */
export const getAccessList = (data, callback) => ({
  type: GET_ACCESS_LIST,
  payload: { data },
  callback
});

/** Call process to get Access list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ACCESS_LIST_PLUS
 */
export const getAccessListPlus = (data, callback) => ({
  type: GET_ACCESS_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get SchedulingAlert
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_SCHEDULING_ALERT
 */
export const getSchedulingAlert = (data, callback) => ({
  type: GET_SCHEDULING_ALERT,
  payload: { data },
  callback
});

/**
 * Call process to get SchedulingAlert list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_SCHEDULING_ALERT_LIST
 */
export const getSchedulingAlertList = (data, callback) => ({
  type: GET_SCHEDULING_ALERT_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get SchedulingAlert list
 * @param  { object } data - Pagination data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_SCHEDULING_ALERT_LIST_PLUS
 */
export const getSchedulingAlertListPlus = (data, callback) => ({
  type: GET_SCHEDULING_ALERT_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get ProteinEnergeticWear
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PROTEIN_ENERGETIC_WEAR
 */
export const getProteinEnergeticWear = (data, callback) => ({
  type: GET_PROTEIN_ENERGETIC_WEAR,
  payload: { data },
  callback
});

/**
 * Call process to get ProteinEnergeticWear list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PROTEIN_ENERGETIC_WEAR_LIST
 */
export const getProteinEnergeticWearList = (data, callback) => ({
  type: GET_PROTEIN_ENERGETIC_WEAR_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get ProteinEnergeticWear list
 * @param  { object } data - Pagination data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PROTEIN_ENERGETIC_WEAR_LIST
 */
export const getProteinEnergeticWearListPlus = (data, callback) => ({
  type: GET_PROTEIN_ENERGETIC_WEAR_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get GeneralSocialTSocialRisk
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_GENERAL_SOCIAL_T_SOCIAL_RISK
 */
export const getGeneralSocialTSocialRisk = (data, callback) => ({
  type: GET_GENERAL_SOCIAL_T_SOCIAL_RISK,
  payload: { data },
  callback
});

/**
 * Call process to get GeneralSocialTSocialRisk list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_GENERAL_SOCIAL_T_SOCIAL_RISK_LIST
 */
export const getGeneralSocialTSocialRiskList = (data, callback) => ({
  type: GET_GENERAL_SOCIAL_T_SOCIAL_RISK_LIST,
  payload: { data },
  callback
});

/** Call process to get GeneralSocialTSocialRisk list plus
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_GENERAL_SOCIAL_T_SOCIAL_RISK_LIST_PLUS
 */
export const getGeneralSocialTSocialRiskListPlus = (data, callback) => ({
  type: GET_GENERAL_SOCIAL_T_SOCIAL_RISK_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get Nursing Education
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_NURSING_EDUCATION
 */
export const getNursingEducation = (data, callback) => ({
  type: GET_NURSING_EDUCATION,
  payload: { data },
  callback
});

/**
 * Call process to get Nursing Education list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_NURSING_EDUCATION_LIST
 */
export const getNursingEducationList = (data, callback) => ({
  type: GET_NURSING_EDUCATION_LIST,
  payload: { data },
  callback
});

/** Call process to get nursing list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ACCESS_LIST_PLUS
 */
export const getNursingEducationListPlus = (data, callback) => ({
  type: GET_NURSING_EDUCATION_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get Assessment in Psychology
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ASSESMENT_IN_PSYCHOLOGY
 */
export const getAssessmentInPsychology = (data, callback) => ({
  type: GET_ASSESMENT_IN_PSYCHOLOGY,
  payload: { data },
  callback
});

/**
 * Call process to get Assessment in Psychology list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ASSESMENT_IN_PSYCHOLOGY_LIST
 */
export const getAssessmentInPsychologyList = (data, callback) => ({
  type: GET_ASSESMENT_IN_PSYCHOLOGY_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get Dissent withoout Psychology Assessment
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT
 */
export const getDissentWithoutPsychologyAssessment = (data, callback) => ({
  type: GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT,
  payload: { data },
  callback
});

/**
 * Call process to get Patient Events
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PATIENT_EVENTS
 */
export const getPatientEvents = (data, callback) => ({
  type: GET_PATIENT_EVENTS,
  payload: { data },
  callback
});

/**
 * Call process to getget Dissent withoout Psychology Assessment list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT_LIST
 */
export const getDissentWithoutPsychologyAssessmentList = (data, callback) => ({
  type: GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT_LIST,
  payload: { data },
  callback
});

/**
 * Call process to getget Dissent withoout Psychology Assessment list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT_LIST
 */
export const getDissentWithoutPsychologyAssessmentListPlus = (
  data,
  callback
) => ({
  type: GET_DISSENT_WITHOUT_PSYCHOLOGY_ASSESSMENT_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get Patient Events list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PATIENT_EVENTS_LIST
 */
export const getPatientEventsList = (data, callback) => ({
  type: GET_PATIENT_EVENTS_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get Patient Events list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PATIENT_EVENTS_LIST
 */
export const getPatientEventsListPlus = (data, callback) => ({
  type: GET_PATIENT_EVENTS_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get Periodicity Attention
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PERIODICITY_ATTENTION
 */
export const getPeriodicityAttention = (data, callback) => ({
  type: GET_PERIODICITY_ATTENTION,
  payload: { data },
  callback
});

/**
 * Call process to get Periodicity Attention list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PERIODICITY_ATTENTION_LIST
 */
export const getPeriodicityAttentionList = (data, callback) => ({
  type: GET_PERIODICITY_ATTENTION_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get ConstructionAccessAssessment
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_CONSTRUCTION_ACCESS_ASSESSMENT
 */
export const getConstructionAccessAssessment = (data, callback) => ({
  type: GET_CONSTRUCTION_ACCESS_ASSESSMENT,
  payload: { data },
  callback
});

/**
 * Call process to get ConstructionAccessAssessment list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_CONSTRUCTION_ACCESS_ASSESSMENT_LIST
 */
export const getConstructionAccessAssessmentList = (data, callback) => ({
  type: GET_CONSTRUCTION_ACCESS_ASSESSMENT_LIST,
  payload: { data },
  callback
});

/** Call process to get construction accessAssessment
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ACCESS_LIST_PLUS
 */
export const getConstructionAccessAssessmentListPlus = (data, callback) => ({
  type: GET_CONSTRUCTION_ACCESS_ASSESSMENT_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get General Social Risk Register
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_GENERAL_SOCIAL_RISK_REGISTER
 */
export const getGeneralSocialRiskRegister = (data, callback) => ({
  type: GET_GENERAL_SOCIAL_RISK_REGISTER,
  payload: { data },
  callback
});

/**
 * Call process to get General Social Risk Register list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_GENERAL_SOCIAL_RISK_REGISTER_LIST
 */
export const getGeneralSocialRiskRegisterList = (data, callback) => ({
  type: GET_GENERAL_SOCIAL_RISK_REGISTER_LIST,
  payload: { data },
  callback
});

/** Call process to get general social risk register list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ACCESS_LIST_PLUS
 */
export const getGeneralSocialRiskRegisterListPlus = (data, callback) => ({
  type: GET_GENERAL_SOCIAL_RISK_REGISTER_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get Follow Up Absenteeism Adherence
 * @param  { object } data - ClinicId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE
 */
export const getFollowUpAbsenteeismAdherence = (data, callback) => ({
  type: GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE,
  payload: { data },
  callback
});

/**
 * Call process to get Follow Up Absenteeism Adherence list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE_LIST
 */
export const getFollowUpAbsenteeismAdherenceList = (data, callback) => ({
  type: GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE_LIST,
  payload: { data },
  callback
});

/**
 * Call process to get Follow Up Absenteeism Adherence list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE_LIST
 */
export const getFollowUpAbsenteeismAdherenceListPlus = (data, callback) => ({
  type: GET_FOLLOW_UP_ABSENTEEISM_ADHERENCE_LIST_PLUS,
  payload: { data },
  callback
});

/**
 * Call process to get clinics list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ADMON_CODES_BY_ENTITY
 */
export const getAdmonCodesByEntity = (data, callback) => ({
  type: GET_ADMON_CODES_BY_ENTITY,
  payload: { data },
  callback
});

/**
 * Call process to get last update
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_LAST_UPDATE
 */
export const getLastUpdate = (callback) => ({
  type: GET_LAST_UPDATE,
  callback
});
